import { ExactUrlFilter } from './ExactUrlFilter.mjs'
import { PrefixUrlFilter } from './PrefixUrlFilter.mjs'
import { NoOpUrlFilter } from './NoOpUrlFilter.mjs'
import { ContainsUrlFilter } from './ContainsUrlFilter.mjs'
import { SuffixUrlFilter } from './SuffixUrlFilter.mjs'

export const sessionUrlFilterClassMap = {
  [ExactUrlFilter.TYPE]: ExactUrlFilter,
  [PrefixUrlFilter.TYPE]: PrefixUrlFilter,
  [ContainsUrlFilter.TYPE]: ContainsUrlFilter,
  [NoOpUrlFilter.TYPE]: NoOpUrlFilter,
  [SuffixUrlFilter.TYPE]: SuffixUrlFilter,
}
